import React from "react"

const UsageSummary = ({
  cap,
  remainingGigs,
  total,
  nightGigs,
  isThrottle,
  nightTotal,
}) => {
  let usageString = "Usage"
  if (nightGigs) usageString = `Daytime ${usageString}`
  if (isThrottle) usageString = `Unthrottled ${usageString}`

  return (
    <p style={{ textAlign: "left", fontSize: "19px" }}>
      <span>
        Bandwidth Allowed: {cap} GB
        <br />
      </span>
      <span>
        {usageString}: {total} GB
        <br />
      </span>
      <span>Bandwidth Remaining: {Math.max(remainingGigs, 0.0)} GB</span>
      {nightGigs && (
        <span>
          <br />
          Night Usage: {nightTotal}
        </span>
      )}
    </p>
  )
}

export default UsageSummary
